<template>
    <el-container>
        <el-header height="80px">
            <el-menu class="el-menu-demo" :default-active="activeIndex" mode="horizontal" id="elMenu"
                @select="handleSelect">
                <el-menu-item @click="back()">后退</el-menu-item>
                <el-menu-item index="/averageAnalysisIndex">首页</el-menu-item>
                <el-menu-item index="/averageAnalysis/simpleAverageData?bridgeId=077b2024-c60f-4f34-80f9-467bb24cc324">统计数据表</el-menu-item>
                <el-submenu
                    :index="'/averageAnalysis/dataHistory?bridgeId=077b2024-c60f-4f34-80f9-467bb24cc324&scenarioId=TBD'">
                    <template slot="title">数据历史</template>
                    <el-menu-item
                        index="/averageAnalysis/dataHistory?bridgeId=077b2024-c60f-4f34-80f9-467bb24cc324&scenarioId=TBD">
                        查询数据历史
                    </el-menu-item>
                    <el-menu-item index="/averageAnalysis/dataHistory?bridgeId=077b2024-c60f-4f34-80f9-467bb24cc324">
                        自定义数据历史
                    </el-menu-item>
                </el-submenu>
            </el-menu>
            <HeaderTime bridgeName="ADMIN" :bridgeId="bridgeId" :id2Path="id2Path" :envInfo="envInfo">
            </HeaderTime>
        </el-header>
        <el-main class="el-main averageAnalysis">
            <router-view></router-view>
        </el-main>
    </el-container>
</template>
<script>
export default {
    name: "averageAnalysis",
    data() {
        return {
            bridgeId: "077b2024-c60f-4f34-80f9-467bb24cc324",
            envInfo: {
                envId: "--",
                weather: "--",
                humidity: "--",
                temperature: "--",
                weatherAbsoluteHumidity: "--",
            },
            id2Path: {},
            activeIndex: "",
            historyScenarioList: [],
        };
    },
    mounted() {
        this.activeIndex = this.$route.fullPath;

        document.getElementById("elMenu").addEventListener(
            "mousewheel",
            (e) => {
                let scrollWidth = document.getElementById("elMenu").scrollWidth;
                let clientWidth = document.getElementById("elMenu").clientWidth;

                let scrollMin = 0;
                let scrollMax = scrollWidth - clientWidth;
                let step = 30;

                if (e.deltaY > 0) {
                    document.getElementById("elMenu").scrollLeft += step;
                    if (document.getElementById("elMenu").scrollLeft > scrollMax) {
                        document.getElementById("elMenu").scrollLeft = scrollMax;
                    }
                } else if (e.deltaY < 0) {
                    document.getElementById("elMenu").scrollLeft += step * -1;
                    if (document.getElementById("elMenu").scrollLeft < scrollMin) {
                        document.getElementById("elMenu").scrollLeft = scrollMin;
                    }
                }
            },
            true
        );
    },
    watch: {
        $route() {
            this.activeIndex = this.$route.fullPath;
        },
    },
    methods: {
        back() {
            window.history.back();
        },
        handleSelect(key) {
            if (key !== this.activeIndex) {
                this.activeIndex = key;
                this.$router.push(key);
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.el-menu-demo {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: flex-start;
    align-items: center;

    overflow-x: scroll;
}

::-webkit-scrollbar {
    width: 8px;
    height: 8px;
    background: transparent;
    display: none;
}
</style>